import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameInformationButton} from '../../../../shared/scripts/ui_game/ui_game_help_buttons/ui_game_help_buttons_information_button/UIGameInformationButton'
import {UIGameFullScreenButton} from '../../../../shared/scripts/ui_game/ui_game_help_buttons/UIGameFullScreenButton'
import {UIGameHelpButtons} from '../../../../shared/scripts/ui_game/ui_game_help_buttons/UIGameHelpButtons'
import UIGameRulesButton from '../../../../shared/scripts/ui_game/ui_game_help_buttons/UIGameRulesButton'
import {GameSettings} from '@colonist/game-base-types'

export class UIWGameHelpButtons extends UIGameHelpButtons {
    private fullScreenButton: UIGameFullScreenButton

    protected createOtherHelpButtons(gameSettings: GameSettings) {
        this.rulesButton = new UIGameRulesButton(this.uiGameHelpButtonController, this.helpButtonsContainer, gameSettings)
        if(UIUtilsEjsVariables.isUserOnMobile && !UIUtilsEjsVariables.isUserOnDiscordMobile) return

        if(!UIUtilsEjsVariables.isUserOnDiscord) this.fullScreenButton = new UIGameFullScreenButton(this.uiGameHelpButtonController, this.helpButtonsContainer)
        this.informationButton = new UIGameInformationButton(this.uiGameHelpButtonController, this.helpButtonsContainer)
    }

    protected override onBeginnerModeStart() {
        super.onBeginnerModeStart()
        if(this.fullScreenButton != undefined) this.fullScreenButton.gameHelpButtonContainer.style.display = 'none'
    }

    closeAllContainers(): void {
        super.closeAllContainers()
        this.informationButton?.setContainerActive(false)
    }
}
